import { jsx as _jsx } from "react/jsx-runtime";
export var DefaultFooter = function DefaultFooter() {
  return /*#__PURE__*/_jsx("div", {
    children: "\xA92014-\u73B0\u5728 \u4E07\u5E2E\u661F\u661F\u5145\u7535\u79D1\u6280\u6709\u9650\u516C\u53F8 All rights reserved."
  });
};
export default DefaultFooter;